"use client";

import { useState, useEffect, useCallback } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { Bot, Cpu, Laptop, Globe, ArrowRight, Sparkles, Blocks, CircleCheck as CheckCircle2, TrendingUp, Zap, Layers } from "lucide-react";
interface ModuleData {
  id: string;
  code: string;
  trackId: "duplo" | "whalesbot";
  title: {
    vi: string;
    en: string;
  };
  trackName: {
    vi: string;
    en: string;
  };
  age: string;
  hardware: {
    vi: string;
    en: string;
  };
  requiresPc: boolean;
  desc: {
    vi: string;
    en: string;
  };
  route: string;
}
const MODULES: ModuleData[] = [{
  id: "d1",
  code: "D1",
  trackId: "duplo",
  title: {
    vi: "Bé làm kỹ sư",
    en: "Little Engineer"
  },
  trackName: {
    vi: "Duplo Foundation",
    en: "Duplo Foundation"
  },
  age: "4–6",
  hardware: {
    vi: "Lắp ráp Duplo",
    en: "Duplo Bricks"
  },
  requiresPc: false,
  desc: {
    vi: "Khám phá nguyên lý cơ khí đơn giản và xây dựng các mô hình sáng tạo đầu đời.",
    en: "Explore fundamental mechanical concepts and build creative brick models."
  },
  route: "/RoboticsCourseD1Page"
}, {
  id: "d2",
  code: "D2",
  trackId: "duplo",
  title: {
    vi: "Thành phố của em",
    en: "My Smart City"
  },
  trackName: {
    vi: "Duplo Foundation",
    en: "Duplo Foundation"
  },
  age: "4–6",
  hardware: {
    vi: "Lắp ráp Duplo",
    en: "Duplo Bricks"
  },
  requiresPc: false,
  desc: {
    vi: "Thiết kế các công trình đô thị và hạ tầng giao thông thông minh thu nhỏ.",
    en: "Design urban structures and smart transport infrastructure in miniature."
  },
  route: "/RoboticsCourseD2Page"
}, {
  id: "d3",
  code: "D3",
  trackId: "duplo",
  title: {
    vi: "Cỗ máy kỳ diệu",
    en: "Miraculous Machines"
  },
  trackName: {
    vi: "Duplo Foundation",
    en: "Duplo Foundation"
  },
  age: "4–6",
  hardware: {
    vi: "Lắp ráp Duplo",
    en: "Duplo Bricks"
  },
  requiresPc: false,
  desc: {
    vi: "Tìm hiểu bánh răng, đòn bẩy và các cơ cấu truyền động cơ bản.",
    en: "Learn about gears, levers, and essential mechanical motion mechanisms."
  },
  route: "/RoboticsCourseD3Page"
}, {
  id: "d4",
  code: "D4",
  trackId: "duplo",
  title: {
    vi: "Động cơ nhí",
    en: "Junior Motor Mechanics"
  },
  trackName: {
    vi: "Duplo Foundation",
    en: "Duplo Foundation"
  },
  age: "4–6",
  hardware: {
    vi: "Lắp ráp Duplo & Động cơ",
    en: "Duplo Bricks & Motors"
  },
  requiresPc: false,
  desc: {
    vi: "Tích hợp động cơ điện sơ khai giúp các mô hình tự chuyển động linh hoạt.",
    en: "Integrate basic electric motors to power autonomous mechanical builds."
  },
  route: "/RoboticsCourseD4Page"
}, {
  id: "hp1",
  code: "HP1",
  trackId: "whalesbot",
  title: {
    vi: "Kỹ sư cơ khí nhí",
    en: "Junior Mechanical Engineer"
  },
  trackName: {
    vi: "WhalesBot Programming",
    en: "WhalesBot Programming"
  },
  age: "7+",
  hardware: {
    vi: "WhalesBot AI Module 1S",
    en: "WhalesBot AI Module 1S"
  },
  requiresPc: true,
  desc: {
    vi: "Xây dựng cấu trúc robot phức tạp và làm quen với tư duy lập trình khối.",
    en: "Build complex robotic structures and develop introductory coding logic."
  },
  route: "/RoboticsCourseHP1Page"
}, {
  id: "hp2",
  code: "HP2",
  trackId: "whalesbot",
  title: {
    vi: "Robot biết cảm nhận",
    en: "Sensing Robots"
  },
  trackName: {
    vi: "WhalesBot Programming",
    en: "WhalesBot Programming"
  },
  age: "7+",
  hardware: {
    vi: "WhalesBot AI Module 1S",
    en: "WhalesBot AI Module 1S"
  },
  requiresPc: true,
  desc: {
    vi: "Ứng dụng cảm biến hồng ngoại, va chạm và ánh sáng vào điều khiển robot.",
    en: "Incorporate infrared, touch, and light sensors into robotic behaviors."
  },
  route: "/RoboticsCourseHP2Page"
}, {
  id: "hp3",
  code: "HP3",
  trackId: "whalesbot",
  title: {
    vi: "Xe robot đầu tiên",
    en: "First Robot Car"
  },
  trackName: {
    vi: "WhalesBot Programming",
    en: "WhalesBot Programming"
  },
  age: "7+",
  hardware: {
    vi: "WhalesBot AI Module 1S",
    en: "WhalesBot AI Module 1S"
  },
  requiresPc: true,
  desc: {
    vi: "Lập trình điều khiển chuyển động bánh xe và điều hướng chính xác trong không gian.",
    en: "Program wheel movement algorithms and precise directional navigation."
  },
  route: "/RoboticsCourseHP3Page"
}, {
  id: "hp4",
  code: "HP4",
  trackId: "whalesbot",
  title: {
    vi: "Xe robot thông minh",
    en: "Smart Robot Car"
  },
  trackName: {
    vi: "WhalesBot Programming",
    en: "WhalesBot Programming"
  },
  age: "7+",
  hardware: {
    vi: "WhalesBot AI Module 1S",
    en: "WhalesBot AI Module 1S"
  },
  requiresPc: true,
  desc: {
    vi: "Xử lý chướng ngại vật tự động và theo dõi đường đi thông qua thuật toán.",
    en: "Implement automated line-following and real-time obstacle avoidance."
  },
  route: "/RoboticsCourseHP4Page"
}, {
  id: "hp5",
  code: "HP5",
  trackId: "whalesbot",
  title: {
    vi: "Thành phố xe tự lái",
    en: "Autonomous Driving City"
  },
  trackName: {
    vi: "WhalesBot Programming",
    en: "WhalesBot Programming"
  },
  age: "7+",
  hardware: {
    vi: "WhalesBot AI Module 1S",
    en: "WhalesBot AI Module 1S"
  },
  requiresPc: true,
  desc: {
    vi: "Mô phỏng hệ thống giao thông tự hành thông minh với thuật toán AI phức hợp.",
    en: "Simulate smart autonomous traffic systems using compound AI algorithms."
  },
  route: "/RoboticsCourseHp5Page"
}, {
  id: "hp6",
  code: "HP6",
  trackId: "whalesbot",
  title: {
    vi: "Robot nhiệm vụ",
    en: "Mission Challenge Robot"
  },
  trackName: {
    vi: "WhalesBot Programming",
    en: "WhalesBot Programming"
  },
  age: "7+",
  hardware: {
    vi: "WhalesBot AI Module 1S",
    en: "WhalesBot AI Module 1S"
  },
  requiresPc: true,
  desc: {
    vi: "Giải quyết các sa bàn thử thách thực tế chuẩn bị cho thi đấu robotics.",
    en: "Solve complex arena mission challenges in preparation for robotics competitions."
  },
  route: "/RoboticsCourseHP6Page"
}];
export default function RoboticsPathwayCopy() {
  const [lang, setLang] = useState<"vi" | "en">("vi");
  useEffect(() => {
    const saved = localStorage.getItem("roboto_lang");
    if (saved === "en" || saved === "vi") {
      setLang(saved);
    }
    const handleLangChange = (e: Event) => {
      const customEvent = e as CustomEvent;
      if (customEvent.detail && (customEvent.detail === "vi" || customEvent.detail === "en")) {
        setLang(customEvent.detail);
      } else {
        const current = localStorage.getItem("roboto_lang");
        if (current === "en" || current === "vi") {
          setLang(current);
        }
      }
    };
    window.addEventListener("roboto-lang-change", handleLangChange);
    return () => window.removeEventListener("roboto-lang-change", handleLangChange);
  }, []);
  const setLanguage = useCallback((newLang: "vi" | "en") => {
    setLang(newLang);
    localStorage.setItem("roboto_lang", newLang);
    window.dispatchEvent(new CustomEvent("roboto-lang-change", {
      detail: newLang
    }));
  }, []);
  return <section id="coreroboticsmodules" data-nav="light" className="relative bg-background text-foreground py-16 md:py-24 overflow-hidden">
      {/* Blueprint Grid Texture Background */}
      <div className="absolute inset-0 pointer-events-none opacity-[0.04] bg-[linear-gradient(to_right,var(--color-foreground)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-foreground)_1px,transparent_1px)] bg-[size:32px_32px]" aria-hidden="true" />

      {/* Decorative Blueprint Accent Circles */}
      <div className="absolute -top-24 -left-24 size-96 rounded-full bg-primary/10 blur-3xl pointer-events-none" aria-hidden="true" />
      <div className="absolute -bottom-24 -right-24 size-96 rounded-full bg-secondary/20 blur-3xl pointer-events-none" aria-hidden="true" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Header Block with Language Toggle */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12 border-b border-border/80 pb-8">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 border border-primary/20 text-primary text-xs font-semibold uppercase tracking-wider mb-4">
              <Sparkles className="size-3.5" />
              <span>
                {lang === "vi" ? "Khung Chương Trình Chuẩn" : "Standardized Framework"}
              </span>
            </div>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-foreground">
              {lang === "vi" ? "10 HỌC PHẦN ROBOTICS CỐT LÕI" : "10 Core Robotics Modules"}
            </h2>
            <p className="font-sans text-muted-foreground text-base sm:text-lg mt-3 leading-relaxed">
              {lang === "vi" ? "Các học phần độc lập được thiết kế chuẩn hóa, chia làm 2 lộ trình chuyên sâu: Lộ trình Duplo Nền Tảng (D1–D4) và Lộ trình Lập Trình WhalesBot (HP1–HP6)." : "Individual standardized modules structured into two specialized tracks: Duplo Foundation Track (D1–D4) and WhalesBot Programming Track (HP1–HP6)."}
            </p>
          </div>

          {/* Bilingual Language Switcher Button */}
          <div className="flex items-center gap-1.5 bg-muted/80 p-1 rounded-lg border border-border shrink-0 self-start md:self-auto">
            <Globe className="size-4 text-muted-foreground ml-2 mr-1" />
            <Button variant={lang === "vi" ? "default" : "ghost"} size="sm" onClick={() => setLanguage("vi")} className="text-xs h-8 px-3 font-medium">
              TIẾNG VIỆT
            </Button>
            <Button variant={lang === "en" ? "default" : "ghost"} size="sm" onClick={() => setLanguage("en")} className="text-xs h-8 px-3 font-medium">
              ENGLISH
            </Button>
          </div>
        </div>

        {/* Track Overview Banner */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
          <div className="bg-card border border-border rounded-xl p-5 shadow-xs flex items-start gap-4">
            <div className="size-10 rounded-lg bg-secondary/20 text-secondary-foreground flex items-center justify-center shrink-0">
              <Blocks className="size-5" />
            </div>
            <div>
              <div className="flex items-center gap-2">
                <span className="font-serif font-bold text-lg text-foreground">
                  D1 – D4
                </span>
                <Badge variant="secondary" className="text-xs">
                  {lang === "vi" ? "Độ tuổi 4–6" : "Ages 4–6"}
                </Badge>
              </div>
              <p className="text-xs font-semibold text-secondary-foreground mt-0.5">
                {lang === "vi" ? "Duplo Foundation Track" : "Duplo Foundation Track"}
              </p>
              <p className="text-xs text-muted-foreground mt-1 flex items-center gap-1">
                <CheckCircle2 className="size-3 text-secondary" />
                {lang === "vi" ? "Không dùng máy tính – Trải nghiệm lắp ráp trực quan" : "No computer required – Hands-on tactile building"}
              </p>
            </div>
          </div>

          <div className="bg-card border border-border rounded-xl p-5 shadow-xs flex items-start gap-4">
            <div className="size-10 rounded-lg bg-primary/10 text-primary flex items-center justify-center shrink-0">
              <Bot className="size-5" />
            </div>
            <div>
              <div className="flex items-center gap-2">
                <span className="font-serif font-bold text-lg text-foreground">
                  HP1 – HP6
                </span>
                <Badge variant="default" className="text-xs">
                  {lang === "vi" ? "Độ tuổi 7+" : "Ages 7+"}
                </Badge>
              </div>
              <p className="text-xs font-semibold text-primary mt-0.5">
                {lang === "vi" ? "WhalesBot Programming Track" : "WhalesBot Programming Track"}
              </p>
              <p className="text-xs text-muted-foreground mt-1 flex items-center gap-1">
                <Laptop className="size-3 text-primary" />
                {lang === "vi" ? "WhalesBot AI Module 1S – Lập trình trên máy tính" : "WhalesBot AI Module 1S – Computer programming"}
              </p>
            </div>
          </div>
        </div>

        {/* Visual Pathway Diagram & Supporting Photograph */}
        <div className="mb-12 rounded-2xl bg-slate-900 border border-slate-800 shadow-xl p-6 sm:p-8 relative overflow-hidden text-white">
          {/* Technical Blueprint Overlay */}
          <div className="absolute inset-0 pointer-events-none opacity-10 bg-[linear-gradient(to_right,#ffffff_1px,transparent_1px),linear-gradient(to_bottom,#ffffff_1px,transparent_1px)] bg-[size:24px_24px]" aria-hidden="true" />
          <div className="absolute -top-24 -right-24 size-80 rounded-full bg-primary/25 blur-3xl pointer-events-none" aria-hidden="true" />
          <div className="absolute -bottom-24 -left-24 size-80 rounded-full bg-secondary/20 blur-3xl pointer-events-none" aria-hidden="true" />

          <div className="relative z-10 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
            {/* Left Column: Visual Pathway Step Nodes */}
            <div className="lg:col-span-7 flex flex-col justify-between">
              <div className="mb-6">
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary/20 border border-secondary/40 text-secondary text-xs font-semibold uppercase tracking-wider mb-3">
                  <TrendingUp className="size-3.5" />
                  <span>
                    {lang === "vi" ? "Sơ Đồ Tiến Trình Học Tập" : "Learning Progression Diagram"}
                  </span>
                </div>
                <h3 className="font-serif text-2xl sm:text-3xl font-bold text-white tracking-tight">
                  {lang === "vi" ? "Lộ Trình Tăng Tốc Kỹ Thuật Robotics" : "Robotics Engineering Advancement Pathway"}
                </h3>
                <p className="text-slate-300 text-sm mt-2 leading-relaxed font-sans">
                  {lang === "vi" ? "Mô hình tích hợp từ nhận thức tư duy cơ khí ban đầu đến lập trình thuật toán AI tự hành và sa bàn thi đấu chuẩn quốc tế." : "An integrated framework progressing from foundational mechanical intuition to AI autonomous algorithms and competition arena preparation."}
                </p>
              </div>

              {/* Pathway Diagram Steps */}
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                {/* Step 1 */}
                <div className="bg-slate-800/80 border border-slate-700/80 rounded-xl p-4 flex flex-col justify-between relative group hover:border-secondary transition-colors">
                  <div>
                    <div className="flex items-center justify-between mb-2">
                      <span className="text-[10px] font-mono font-bold uppercase tracking-wider text-secondary px-2 py-0.5 rounded bg-secondary/10 border border-secondary/20">
                        01. FOUNDATION
                      </span>
                      <span className="text-[10px] text-slate-400 font-semibold">4–6 YRS</span>
                    </div>
                    <h4 className="font-serif font-bold text-sm text-white mb-1">
                      D1 – D4 Duplo
                    </h4>
                    <p className="text-xs text-slate-300 leading-snug">
                      {lang === "vi" ? "Khám phá cơ khí đơn giản, truyền động bánh răng & động cơ điện" : "Fundamental mechanics, gear ratios & junior motor drives"}
                    </p>
                  </div>
                  <div className="mt-4 pt-2 border-t border-slate-700/60 flex items-center justify-between text-[11px] text-slate-400">
                    <span>{lang === "vi" ? "Trải nghiệm" : "Mode"}</span>
                    <span className="text-secondary font-semibold">100% Tactile</span>
                  </div>
                </div>

                {/* Step 2 */}
                <div className="bg-slate-800/80 border border-slate-700/80 rounded-xl p-4 flex flex-col justify-between relative group hover:border-primary transition-colors">
                  <div>
                    <div className="flex items-center justify-between mb-2">
                      <span className="text-[10px] font-mono font-bold uppercase tracking-wider text-primary px-2 py-0.5 rounded bg-primary/10 border border-primary/20">
                        02. CODING & SENSORS
                      </span>
                      <span className="text-[10px] text-slate-400 font-semibold">7+ YRS</span>
                    </div>
                    <h4 className="font-serif font-bold text-sm text-white mb-1">
                      HP1 – HP3 WhalesBot
                    </h4>
                    <p className="text-xs text-slate-300 leading-snug">
                      {lang === "vi" ? "Lập trình khối Scratch, tích hợp cảm biến & điều hướng xe robot" : "Block coding logic, sensor hardware integration & car steering"}
                    </p>
                  </div>
                  <div className="mt-4 pt-2 border-t border-slate-700/60 flex items-center justify-between text-[11px] text-slate-400">
                    <span>{lang === "vi" ? "Phần cứng" : "Hardware"}</span>
                    <span className="text-primary font-semibold">AI Module 1S</span>
                  </div>
                </div>

                {/* Step 3 */}
                <div className="bg-slate-800/80 border border-slate-700/80 rounded-xl p-4 flex flex-col justify-between relative group hover:border-amber-400 transition-colors">
                  <div>
                    <div className="flex items-center justify-between mb-2">
                      <span className="text-[10px] font-mono font-bold uppercase tracking-wider text-amber-400 px-2 py-0.5 rounded bg-amber-400/10 border border-amber-400/20">
                        03. ARENA MASTERY
                      </span>
                      <span className="text-[10px] text-slate-400 font-semibold">7+ YRS</span>
                    </div>
                    <h4 className="font-serif font-bold text-sm text-white mb-1">
                      HP4 – HP6 Advanced
                    </h4>
                    <p className="text-xs text-slate-300 leading-snug">
                      {lang === "vi" ? "Thuật toán xe tự hành AI, xử lý va chạm & chinh phục sa bàn" : "Autonomous AI algorithms, line-tracking & arena missions"}
                    </p>
                  </div>
                  <div className="mt-4 pt-2 border-t border-slate-700/60 flex items-center justify-between text-[11px] text-slate-400">
                    <span>{lang === "vi" ? "Mục tiêu" : "Target"}</span>
                    <span className="text-amber-400 font-semibold">
                      {lang === "vi" ? "Thi đấu Arena" : "Arena Challenges"}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column: High-Acuity Technical Photograph */}
            <div className="lg:col-span-5 relative">
              <div className="relative rounded-xl overflow-hidden border border-slate-700/80 shadow-xl group">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_learning_progression_pathway.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_learning_progression_pathway.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robotics_learning_progression_pathway.webp-wvc-sizes" alt="ROBOTO Technical Academy Robotics Progression Diagram and Lab Environment" className="w-full h-64 sm:h-72 object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-950/90 via-slate-950/20 to-transparent" />

                <div className="absolute bottom-3 left-3 right-3 p-3 rounded-lg bg-slate-900/85 backdrop-blur-md border border-slate-700/80 flex items-center justify-between">
                  <div className="flex items-center gap-2.5">
                    <div className="size-8 rounded-md bg-primary/20 border border-primary/40 flex items-center justify-center text-primary shrink-0">
                      <Zap className="size-4" />
                    </div>
                    <div>
                      <p className="text-xs font-semibold text-white">
                        ROBOTO R&D Academy Standard
                      </p>
                      <p className="text-[10px] text-slate-300">
                        {lang === "vi" ? "Môi trường Lab kỹ thuật hiện đại" : "Advanced Engineering Lab Standards"}
                      </p>
                    </div>
                  </div>
                  <span className="text-[10px] font-mono uppercase bg-secondary/20 text-secondary border border-secondary/30 px-2 py-0.5 rounded font-bold">
                    100% STEM
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 10 Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {MODULES.map((item, i) => {
          const isDuplo = item.trackId === "duplo";
          return <Card key={item.id} data-index={i} className="group relative flex flex-col justify-between border-border hover:border-primary/50 transition-all duration-300 shadow-xs hover:shadow-md bg-card overflow-hidden rounded-xl">
                {/* Blueprint Accent Bar */}
                <div className={`h-1.5 w-full ${isDuplo ? "bg-secondary" : "bg-primary"}`} />

                <CardHeader className="pt-5 pb-3">
                  <div className="flex items-center justify-between gap-2 mb-2">
                    <div className="flex items-center gap-2">
                      <span className="font-mono font-bold text-2xl tracking-tight text-foreground bg-muted px-2.5 py-0.5 rounded-md border border-border/80">
                        {item.code}
                      </span>
                      <Badge variant={isDuplo ? "secondary" : "default"} className="text-[11px] font-medium">
                        {item.trackName[lang]}
                      </Badge>
                    </div>
                    <span className="text-xs font-semibold px-2 py-0.5 rounded-md bg-muted text-muted-foreground border border-border/60">
                      {lang === "vi" ? `Tuổi: ${item.age}` : `Age: ${item.age}`}
                    </span>
                  </div>

                  <CardTitle className="font-serif text-xl text-foreground group-hover:text-primary transition-colors leading-snug pt-1">
                    {item.title[lang]}
                  </CardTitle>
                </CardHeader>

                <CardContent className="py-2 flex-grow">
                  <p className="font-sans text-sm text-muted-foreground leading-relaxed">
                    {item.desc[lang]}
                  </p>

                  <div className="mt-4 pt-3 border-t border-border/60 flex flex-wrap items-center gap-y-1.5 gap-x-3 text-xs text-muted-foreground">
                    <span className="inline-flex items-center gap-1 font-medium text-foreground/80">
                      <Cpu className="size-3.5 text-primary" />
                      {item.hardware[lang]}
                    </span>
                    <span className="inline-flex items-center gap-1">
                      {item.requiresPc ? <>
                          <Laptop className="size-3.5 text-primary" />
                          <span className="text-foreground/90 font-medium">
                            {lang === "vi" ? "Cần máy tính" : "Computer required"}
                          </span>
                        </> : <>
                          <CheckCircle2 className="size-3.5 text-secondary" />
                          <span>
                            {lang === "vi" ? "Không máy tính" : "No computer"}
                          </span>
                        </>}
                    </span>
                  </div>
                </CardContent>

                <CardFooter className="pt-3 pb-5">
                  <Button asChild variant={isDuplo ? "secondary" : "default"} size="sm" className="w-full justify-between group/btn font-medium">
                    <Link to={item.route}>
                      <span>
                        {lang === "vi" ? "Xem chi tiết" : "View details"}
                      </span>
                      <ArrowRight className="size-4 transition-transform duration-200 group-hover/btn:translate-x-1" />
                    </Link>
                  </Button>
                </CardFooter>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}